var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.canInteract || _vm.isBooting)?_c('div',{staticClass:"row justify-center items-center absolute-full z-top"},[_c('q-spinner-puff',{attrs:{"color":"accent","size":"50px"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }